// @ts-nocheck



import React from 'react';
import { quarters, quartersEnum } from '../../../../lib/enum';

import { Option, Select } from './../../../../components/ant/Select';



export default (props) => {
  return (
    <Select allowClear mode="multiple" {...props}>
      {Object.keys(quartersEnum).map((quarter) => {
        return (
          <Option key={quarter} value={quartersEnum[quarter]}>
            {quarters[quarter]}
          </Option>);

      })}
    </Select>);

};
